// authServices.js
import { signUp, fetchUserAttributes } from "@aws-amplify/auth";

export async function signUpUser({
  username,
  password,
  email,
  name,
  phone_number,
  accountType,
  businessName,
  country,
  walletCurrency,
}) {
  try {
    const userAttributes = {
      email,
      name,
      phone_number, // Make sure phone_number is in E.164 format
      ...(accountType ? { "custom:accountType": accountType } : {}),
      ...(businessName ? { "custom:businessName": businessName } : {}),
      ...(country ? { "custom:country": country } : {}),
      ...(walletCurrency
        ? { "custom:walletCurrency": walletCurrency.toUpperCase() }
        : {}),
    };
    const signUpResponse = await signUp({
      username,
      password,
      options: {
        userAttributes,
        autoSignIn: {
          enabled: false,
        },
      },
    });

    console.log("Sign up success", signUpResponse);
    return signUpResponse;
  } catch (error) {
    console.error("Error signing up:", error);
    throw error;
  }
}

export async function getTableID() {
  try {
    const user = await fetchUserAttributes();
    return user["custom:TableID"];
  } catch (err) {
    console.log(err);
    return null;
  }
}
